import request from '@/utils/http';
import utils from '@/utils/common';
const apiCrmHost = 'api-lcrm';

// 列表查询-续签登记表
export const contractRenewalRegistrationPage = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/page',
        method: 'post',
        data
    });
};
// 列表查询-续签登记待办列表
export const queryContractRenewalByUserCode = (data) => {
    return request({
        url: apiCrmHost + '/queryContractRenewalByUserCode',
        method: 'post',
        data
    });
};
// 保存-续签表、续签待办表保存（批量）-xsh
// 修改人：lx，wy；2026-1-28：接口地址修改：/contract/renewal/registration/save -> /contract/renewal/registration/v2/save
export const contractRenewalRegistrationSave = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/v2/save',
        method: 'post',
        data
    });
};
// 保存-续签表、续签待办表保存(单个)-xsh
export const contractRenewalRegistrationSingleSave = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/saveDto',
        method: 'post',
        data
    });
};
// 完成待办
export const setHaveDoneApi = (data) => {
    return request({
        url: apiCrmHost + '/setHaveDone',
        method: 'post',
        data
    });
};
// 续签登记导入
export const registrationImportApi = (params) => {
    return request({
        url: `/${apiCrmHost}/contract/renewal/registration/import/update`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 下载模板
export const renewalFileDownloadApi = (params = {}) => {
    return request({
        url: `/${apiCrmHost}/contract/renewal/file/download`,
        method: 'get',
        responseType: 'blob',
        params
    }).then(res => {
        utils.downloadStream(res, params.fileName);
    });
};
// 续签登记详情
export const registrationGetByIdApi = (params) => {
    return request({
        url: `/${apiCrmHost}/contract/renewal/registration/getById`,
        method: 'get',
        params
    }).then(res => res);
};
// 续签登记新增-zxh
export const contractRenewalRegistrationInsert = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/addBatch',
        method: 'post',
        data
    });
};
// 续签登记删除-zxh
export const contractRenewalRegistrationDel = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/remove',
        method: 'DELETE',
        data
    });
};
// 续签登记-流程列表-xz
export const getIflowDetailList = (data) => {
    return request({
        url: apiCrmHost + '/contract/workflow/info/pageWorkflowList',
        method: 'post',
        data
    });
};
// 续签登记-历史列表-xz
export const getHistotyList = (data) => {
    return request({
        url: apiCrmHost + '/contract/modify/record/page',
        method: 'post',
        data
    });
};

// 续签登记-校验退出流程-xz
export const registrationVerify = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/flow/save/verify',
        method: 'post',
        data
    });
};
// 续签登记-保存退出流程-xz
export const saveExitRegistration = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/flow/save',
        method: 'post',
        data
    });
};
// 续签登记-查看退出流程-xz
export const getExitRegistration = (params) => {
    return request({
        url: apiCrmHost + '/contract/renewal/flow/query',
        method: 'get',
        params
    });
};
// 续签登记-提交退出流程-xz
export const submitExitRegistration = (params) => {
    return request({
        url: apiCrmHost + '/contract/renewal/flow/submit',
        method: 'get',
        params
    });
};

// 参考附件下载
export const registraionFileDownload = (params) => {
    return request({
        url: apiCrmHost + '/renewalRegistration/file/download',
        method: 'get',
        responseType: 'blob',
        params
    }).then(res => {
        utils.downloadStream(res, params.fileName);
    });
};
// 续签登记-调用续签登记表的导出前调用这个接口,获取参数后传给报表平台-rzq
export const getRenewalRole = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/report',
        method: 'post',
        data
    });
};
// 续签登记-新导出-rzq
export const renewalExport = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/export/async',
        method: 'post',
        data
    });
};
// 续签登记-新导出-rzq
export const renewalByImportTemplateExport = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/template/withData',
        method: 'post',
        data
    });
};
// 续签登记-行业大类树形结构查询 xsh
export const getIndustryTree = (data) => {
    return request({
        url: apiCrmHost + '/industry/info/tree',
        method: 'post',
        data
    });
};
// 续签登记详情-变更审批列表-xhs
export const getChangeHistroyDataList = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/change/page',
        method: 'post',
        data
    });
};

// 续签登记详情-编辑校验-xhs
export const registrationChangeGetByIdApi = (params) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/infoById',
        method: 'get',
        params
    });
};
// 续签登记-删除数据流程校验-tr
export const registrationDelVerify = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/remove/flow/verify',
        method: 'post',
        data
    });
};
// 续签登记-删除数据流程保存-tr
export const saveDelRegistration = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/remove/flow/save',
        method: 'post',
        data
    });
};
// 续签登记-删除数据流程保存-tr
export const getDelRegistration = (params) => {
    return request({
        url: apiCrmHost + '/contract/renewal/remove/flow/query',
        method: 'get',
        params
    });
};
